import React from "react";
import { Search } from "lucide-react";

export default function ExploreSearchBar({
  value,
  onChange,
  onSubmit,
  placeholder = "Kërko mjek, klinikë ose simptomë…",
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit?.();
    }
  };

  return (
    <div className="p2-explore-search-wrap">
      <div className="p2-explore-search">
        <span className="p2-explore-search-icon">
          <Search className="p2-explore-search-icon-svg" />
        </span>

        <input
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={handleKeyDown}
          type="text"
          className="p2-explore-search-input"
          placeholder={placeholder}
        />

        {value && (
          <button
            type="button"
            onClick={() => onChange?.("")}
            className="p2-explore-search-clear"
          >
            Fshi
          </button>
        )}
      </div>
    </div>
  );
}
